import { UserRole, UserRoleEnum } from "features/users/types";
import { USERS_ROLES_MAP } from "features/users/utils/constants";
import { User } from "types";

export const getRoleLabel = (role: number): UserRole => USERS_ROLES_MAP[role];

export const getRoleIndex = (role: UserRole): number =>
  Number(Object.keys(USERS_ROLES_MAP).find(key => USERS_ROLES_MAP[Number(key)] === role));

export const isRoleHigher = (role1: number, role2: number): boolean => Boolean(role1 < role2);

export const isRoleHigherOrEqual = (role1: number, role2: number): boolean => Boolean(role1 <= role2);

export const isRoleLower = (role1: number, role2: number): boolean => Boolean(role1 > role2);

export const isRoleLowerOrEqual = (role1: number, role2: number): boolean => Boolean(role1 >= role2);

export const getRolesList = (maxAvailableRole: number, isMe: boolean) => {
  const RolesList: { value: number; label: string }[] = [];

  Object.entries(USERS_ROLES_MAP).forEach(([key, label]) => {
    const roleIndex = Number(key);

    if (isMe ? isRoleLower(maxAvailableRole, roleIndex) : isRoleLowerOrEqual(maxAvailableRole, roleIndex)) {
      return;
    }

    RolesList.push({
      value: roleIndex,
      label,
    });
  });

  return RolesList;
};

export const canEditUser = (currentUser: User, role: number, id: string): boolean => {
  const isMe = currentUser.id === id;

  return isRoleHigherOrEqual(currentUser.role, UserRoleEnum.Manager) && (isMe || isRoleHigher(currentUser.role, role));
};

export const canCreateUser = (currentRole: number): boolean => isRoleHigherOrEqual(currentRole, UserRoleEnum.Manager);
